import { useState } from "react"
import { Edit2, Loader2, LocateFixed, MapPinIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip"

import { useLocation } from "./hooks"

const LocationSelector = () => {
  const { address, isLoading, error, getCurrentPosition } = useLocation()
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const [isAddressDialogOpen, setIsAddressDialogOpen] = useState(false)

  const handleGetLocation = async () => {
    setTooltipOpen(false)
    await getCurrentPosition()
  }

  return (
    <>
      <Dialog>
        <DialogTrigger asChild>
          <div
            className={cn(
              "items-center flex-[0_1_auto] overflow-hidden hidden md:flex"
            )}
          >
            <div className="border rounded-lg pl-3 flex items-center gap-1 shrink-0 h-auto">
              <div className="flex items-center gap-2">
                <span className="text-xs font-bold uppercase hidden md:inline">
                  Giao tới
                </span>
                {isLoading ? (
                  <Loader2 className="animate-spin" size={16} />
                ) : (
                  <MapPinIcon className="inline" size={16} />
                )}
                <span className="text-gray-500 text-sm font-light truncate max-w-[150px]">
                  {address?.display || "Nhập địa chỉ của bạn"}
                </span>
                <TooltipProvider>
                  <Tooltip open={tooltipOpen} onOpenChange={setTooltipOpen}>
                    <TooltipTrigger asChild>
                      <Button
                        variant="ghost"
                        size="icon"
                        className="shrink-0"
                        onClick={handleGetLocation}
                      >
                        <LocateFixed className="text-gray-500" size={12} />
                      </Button>
                    </TooltipTrigger>
                    {error && (
                      <TooltipContent className="z-[100000]">
                        <p>{error}</p>
                        <p className="text-xs mt-1">Nhấn để thử lại</p>
                      </TooltipContent>
                    )}
                  </Tooltip>
                </TooltipProvider>
              </div>
            </div>
          </div>
        </DialogTrigger>
        <DialogContent className="max-w-[95vw] md:min-w-[600px] rounded-2xl">
          <DialogHeader className="mt-6">
            <DialogTitle className="text-2xl font-bold">
              Thông tin giao hàng
            </DialogTitle>
          </DialogHeader>

          <div className="flex flex-col gap-4 mt-6 pb-2 px-3">
            <div className="flex gap-5 items-center text-lg">
              <MapPinIcon className="text-gray-800" size={28} strokeWidth={2} />

              <div className="flex flex-col gap-1">
                <span className="font-bold text-gray-950 uppercase text-base">
                  Địa chỉ
                </span>
                <span className="text-gray-700 text-sm">
                  {address?.display || "Vui lòng thay đổi địa chỉ giao hàng"}
                </span>
              </div>

              <Button
                className="ml-auto rounded-3xl text-base px-5 h-10 font-semibold bg-gray-200/60"
                variant="secondary"
              >
                Thay đổi
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={isAddressDialogOpen} onOpenChange={setIsAddressDialogOpen}>
        <DialogContent className="max-w-[95vw] md:min-w-[600px] rounded-2xl"></DialogContent>
      </Dialog>
    </>
  )
}

export { LocationSelector }
